<template>
    <layout>
        <div class="w-100 h-100 d-flex flex-column" style="overflow-y: auto;">
            <div v-if="step===1" class="w-100 d-flex flex-column" style="max-width: 600px; margin: 0 auto;">
                <div class="d-flex justify-content-between p-4 pb-0 mx-2">
                    <b-button variant="outline-primary" size="sm" @click="goToRegister">{{ $t('sign_up').toUpper()}}</b-button>
                    <b-button variant="outline-primary" size="sm" @click="goToLogin">{{
                            $t('login').toUpper()
                        }}</b-button>
                </div>
                <div class="flex-grow-1 w-100 d-flex flex-column p-4 justify-content-center">
                    <div class="mb-5">
                        <h3 class="font-weight-bold text-primary mb-3">{{$t('certificate_programs')}}</h3>
                    </div>
                    <Programs :isPublic="true"/>
                </div>
            </div>
            <div v-if="step === 2" class="w-100 h-100 d-flex flex-column">
                <div class="d-flex justify-content-between p-4 pb-0">
                    <button @click="step = 1" class="btn btn-light btn-40">
                        <i class="ri-arrow-left-line"></i>
                    </button>
                </div>
                <div class="flex-grow-1 w-100 d-flex flex-column p-4 justify-content-center">
                    <div>
                        <div class="d-flex flex-column flex-lg-row align-items-center">
                            <div class="logo-wrapper mb-5">
                                <img src="@/assets/img/bau-logo-for-light.svg" height="40"/>
                            </div>
                        </div>
                        <div class="fadeIn">
                                <ValidationObserver ref="formDataValidation">
                                    <div class="border p-4 bg-white"
                                         style="margin-top: -2px; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px">
                                        <b-row>
                                            <b-col cols="12" md="6">
                                                <ValidationProvider name="national_id" rules="required"
                                                                    v-slot="{ errors }">
                                                    <b-form-group :label="$t('national_id')">
                                                        <b-form-input type="number" v-model="formData.national_id"
                                                                      maxlength="11" :state="errors[0] ? false : null"/>
                                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" md="6">
                                                <ValidationProvider name="birthdate" rules="required"
                                                                    v-slot="{ errors }">
                                                    <b-form-group :label="$t('birthdate')">
                                                        <select-date v-model="formData.birthdate"
                                                                     :validationError="errors[0]"/>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" md="6">
                                                <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                                    <b-form-group :label="$t('name')">
                                                        <b-form-input v-model="formData.name"
                                                                      :state="errors[0] ? false : null"/>
                                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" md="6">
                                                <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                                    <b-form-group :label="$t('surname')">
                                                        <b-form-input v-model="formData.surname"
                                                                      :state="errors[0] ? false : null"/>
                                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" md="6">
                                                <ValidationProvider name="mobile_tel" rules="required"
                                                                    v-slot="{ errors }">
                                                    <b-form-group :label="$t('gsm_no')">
                                                        <phone-number-input v-model="formData.mobile_tel"
                                                                            :only-countries="['TR']"
                                                                            v-mask="'5## ### ## ##'"
                                                                            placeholder="5 _ _  _ _ _  _ _  _ _"
                                                                            :no-country-selector="true"
                                                                            :no-example="true"
                                                                            :disabled="phoneDisabled"/>
                                                        <b-form-invalid-feedback v-if="errors[0]">
                                                            {{ errors[0].replace("13", "10") }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <div class="d-flex justify-content-center mt-3">
                                        <ProcessingButton @click="submitApplication" :label="$t('sign_up')"
                                                          :processing="process" />
<!--                                        <b-button variant="primary" block @click="submitApplication">{{ $t('save') }}-->
<!--                                        </b-button>-->
                                    </div>
                                </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
            <CommonModal ref="smsVerification" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="clear">
                <template v-slot:CommonModalTitle>
                    <template>
                        {{ $t('verification').toUpperCase() }}
                    </template>
                </template>
                <template v-slot:CommonModalContent>
                    <div class="mb-3">
                        <div class="alert alert-info py-2">
                            <strong>{{ formData.mobile_tel }}</strong>
                        </div>
                        <ValidationObserver ref="formSmsVerify">
                            <ValidationProvider name="pin" rules="required" v-slot="{valid, errors}">
                                <sms-input v-model="pin"
                                           ref="smsInput"
                                           :timerFrom="timer"
                                           @timerExpired="timerExpired"
                                />
                            </ValidationProvider>
                        </ValidationObserver>
                        <div class="d-flex justify-content-end mt-2">
                            <ProcessingButton v-if="timer===0" :label="$t('resend_code')" :variant="'link'" :processing="process" @click="sendVerify"/>
                        </div>
                        <div>
                            <ProcessingButton v-if="timer>0" :disabled="pin==null"  :label="$t('verify')" :processing="process" class="d-flex justify-content-center align-item-center w-100 mt-4" @click="verify"/>
                        </div>
                    </div>
                </template>
            </CommonModal>
            <vue-recaptcha ref="recaptcha" size="invisible" sitekey="6LcMe7IrAAAAANoOlSMkWztH9_KFU5Ofj7jUK7n7"/>
        </div>
    </layout>
</template>

<script>
import Layout from '@/modules/ulmerCertificatesApplicationForm/layout/Layout'
import SelectDate from '@/components/interactive-fields/SelectDate'
import PhoneNumberInput from '@/components/elements/PhoneNumberInput'
import ProcessingButton from '@/components/elements/ProcessingButton'
import {VueRecaptcha} from 'vue-recaptcha'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import UlmerCertificatesApplicationsServices from "@/services/UlmerCertificatesApplicationsServices";
import SmsInput from '@/components/elements/SmsInput.vue';
import Programs from "@/modules/ulmerCertificatesApplicationForm/components/Programs.vue";

export default {
    name: "Register",
    components: {
        Programs,
        Layout,
        SelectDate,
        SmsInput,
        PhoneNumberInput,
        ProcessingButton,
        VueRecaptcha,
        ValidationObserver,
        ValidationProvider
    },
    metaInfo() {
        return {
            title: 'Ulmer ' + this.$t('application_system'),
        };
    },
    data() {
        return {
            pin:null,
            loading:false,
            timer:0,
            step: 1,
            selectedProgram: null,
            process: false,
            formStart: false,
            phoneDisabled: false,
            footerInfo: null,
            formData: {
                national_id: null,
                name: null,
                surname: null,
                birthdate: null,
                mobile_tel: null
            },
            expiryIn:0,
        }
    },
    created() {
      this.getPrograms()
    },
    mounted() {
        this.expiryIn=this.$store.getters['UlmerCertificatesApplication/getExpiryIn']
    },
    methods: {
        clear(){
            this.pin=null
            this.timer=0
        },
        goToLogin() {
            this.$router.push('/certificates/application/login');
        },
        goToRegister() {
            this.step = 2;
        },
        async submitApplication() {
           try {
               this.process=true
               this.formData.mobile_tel=this.formData.mobile_tel.replaceAll(' ','')
               const res =await UlmerCertificatesApplicationsServices.register(this.formData)
               this.$toast.success(this.$t('api.' + res.data.data.message))
               this.timer=res.data.data.express_in
               this.$refs.smsVerification.$refs.commonModal.show()
           }catch (err){
               this.showErrors(err,null)
           }finally {
               this.process=false
           }
        },
        async sendVerify(){
            await this.submitApplication()
        },
        async verify(){
            try {
                this.process=true
                this.formData.mobile_tel=this.formData.mobile_tel.replaceAll(' ','')
                this.formData.pin=this.pin
                const res =await UlmerCertificatesApplicationsServices.verifyRegister(this.formData)
                await this.$store.dispatch('UlmerCertificatesApplication/setSessionDeadline')
                this.setWithExpiry('ulmer_application_data', res.data.data, this.expiryIn, true)
                setTimeout(async ()=>{
                    await  this.$router.push('/certificates/application/form');
                },1000)

            }catch (err){
                this.showErrors(err,null)
            }
        },
        timerExpired(){
            this.timer=0
        }
    }
}
</script>

<style scoped>
.hover-shadow:hover {
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

.transition {
    transition: all 0.3s ease;
}
</style>
